import 'dotenv/config';
import axios from 'axios';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: SERVER_URL,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem('token')}`,
  },
});

// Request interceptor to dynamically set the Authorization header
axiosInstance.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for handling errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const checkReg = new RegExp(`${SERVER_URL}/check`);
    if (error.message === 'Network Error') {
      return Promise.reject(error);
    } else if (checkReg && checkReg.test(error.response.config.url)) {
      return Promise.reject(error);
    } else if (error.response.status === 401) {
      window.localStorage.removeItem('token');
      window.location.replace('/login');
      return Promise.reject(error);
    } else {
      return Promise.reject(error);
    }
  },
);

export default axiosInstance;
